import React from "react";
import { Link as RouterLink } from 'react-router-dom';
import labill1 from './../assets/img/Illustrations/Laboratory-amico.svg';
import limseln_sub_1 from './../assets/img/Illustrations/lims_eln_sub_1.png';
import limseln_sub_2 from './../assets/img/Illustrations/lims_eln_sub_2.png';
import dots from './../assets/img/Illustrations/Dots.png';
import lims_eln_main from './../assets/img/Illustrations/lims_eln_mainp.png';
import DownloadBrochure from "./DownloadBrochure";
import Faq from "./Faq";

const LIMS_ELN = () => {

    return (
        <div className='portifoliobody' id="lims-eln">
        <main id="main">
            <section className="about text-start" style={{paddingTop:'60px'}}>
                <div className='landing-page'>
                    <div>
                        <div className="landing-title carousel-container animate__animated animate__fadeInLeft" data-aos="fade-left" data-aos-delay="100">
                            <h1>Lab Iconics Integrated LIMS-ELN Software – Optimize, Automate, and Scale Your Laboratory Operations</h1>
                            <div style={{width:'82%'}}>
                                <p>
                                    Enhance your lab’s efficiency with Lab Iconics LIMS-ELN. Automate workflows, streamline sample management, and accelerate report generation, enabling faster decision making and increased productivity. ​
                                </p>
                            </div>
                            {/* <div className='landing-book-a-demo-div'>
                                <RouterLink to='/demo' href='#REQUEST A DEMO' className='routerLink'>
                                    <div className='landing-book-a-demo-btn'>
                                        Get a Demo
                                    </div>
                                </RouterLink>
                            </div> */}
                            <div className="book_a_demo product-demo" style={{padding:'1rem 1rem 0 0'}}>
                                <RouterLink to='/demo'> 
                                    <button className="book_a_demo_btn product-demo-btn">Get a Demo</button>
                                </RouterLink>
                            </div>
                        </div>
                        {/* <div className="left-img">
                            <img src={dots} alt="" />
                        </div> */}
                        <div className="landing-img-div landing-img-div-lims-eln carousel-container col-12 col-lg-6 animate__animated animate__fadeInRight" data-aos="fade-right" data-aos-delay="100">
                            <img src={lims_eln_main} alt="" style={{marginTop:'3rem'}}/>
                        </div>
                    </div>
                </div>
                <div className="section-container" style={{margin:'0px'}}>
                    <div className="row">
                        <div className="section-pro">
                            <div className="sec-out">
                                <div className="sec-pro-img" data-aos="fade-up" data-aos-delay="100">
                                    <img src={limseln_sub_1} alt=""/>
                                </div>  
                                <div className="sec-pro-desc" data-aos="fade-up" data-aos-delay="100">
                                    <div className="sec-title"><h1>Operational Benefits of an Integrated LIMS & ELN</h1></div>
                                    <ul>
                                        <li><b>Seamless Data Management – </b>Eliminates data silos and centralizes all lab information, ensuring a single source of truth.</li>
                                        <li><b>Automated Workflows & Reduced Errors – </b> Standardizes lab processes, integrates with instruments, and minimizes human errors.</li>
                                        <li><b>Regulatory Compliance Simplification – </b> Ensures adherence to <b>FDA 21 CFR Part 11, GxP, ISO 17025, </b>and other global regulations.</li>
                                        <li><b>Scalability & Flexibility – </b> Supports growth from small R&D labs to large-scale production facilities.</li>
                                        <li><b>Cost & Time Savings – </b> Reduces inefficiencies, minimizes rework, and accelerates drug development cycles.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="section-pro">
                            <div className="sec-out">
                                <div className="sec-pro-desc" data-aos="fade-up" data-aos-delay="100">
                                    <div className="sec-title-2"><h1>Strategic Advantages of an Integrated Approach</h1></div>
                                    <ul style={{padding:'0 50px 0 0'}}>
                                        <li style={{hyphens:'auto'}}><b>End-to-End Traceability –</b> Tracks the entire lifecycle of samples, experiments, and test results for compliance and audits.</li>
                                        <li style={{hyphens:'auto'}}><b>Enhanced Collaboration & Efficiency –  </b>Enables real-time data sharing between R&D, QC, and manufacturing teams.</li>
                                        <li style={{hyphens:'auto'}}><b>Improved Decision-Making – </b> Provides real-time access to data for faster, more informed business decisions. </li>
                                        <li style={{hyphens:'auto'}}><b>AI & Advanced Analytics Integration – </b> Leverages AI to identify trends, optimize workflows, and enhance drug discovery.</li>
                                        <li style={{hyphens:'auto'}}><b>Seamless Integration with Enterprise Systems – </b> Connects with <b> ERP, MES, CDS, and QMS </b>for a unified digital pharma ecosystem.</li>
                                    </ul>
                                </div>
                                <div className="sec-pro-img" data-aos="fade-up" data-aos-delay="100">
                                    <img src={limseln_sub_2} alt="" style={{width:'100%'}}/>
                                </div>  
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
        <div className="down-broch" data-aos="fade-up">
            <DownloadBrochure product={'LIMS-ELN'}/>
        </div>
        <div data-aos="fade-up">
            <Faq product={'LIMS-ELN'}/>
        </div>
    </div>
    )
}

export default LIMS_ELN;